import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import SiteLayout from "@/components/SiteLayout";
import Home from "@/pages/Home";
import PaxPage from "@/pages/PaxPage";
import OtherFurniturePage from "@/pages/OtherFurniturePage";
import KitchenPage from "@/pages/KitchenPage";
import ServiceAreaPage from "@/pages/ServiceAreaPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import SeoCityPage from "@/pages/SeoCityPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ProtectedRoute({ children }) {
  const { admin } = useAuth();
  if (admin === null) return <div className="min-h-screen flex items-center justify-center">…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/pax-montering" element={<PaxPage />} />
                <Route path="/oevrige-moebler" element={<OtherFurniturePage />} />
                <Route path="/ikea-koekken" element={<KitchenPage />} />
                <Route path="/serviceomraade" element={<ServiceAreaPage />} />
                <Route path="/kontakt" element={<ContactPage />} />
                <Route path="/privatlivspolitik" element={<LegalPage kind="privacy" />} />
                <Route path="/handelsbetingelser" element={<LegalPage kind="terms" />} />
                <Route path="/moebelmontering-koebenhavn" element={<SeoCityPage city="koebenhavn" />} />
                <Route path="/moebelmontering-nordsjaelland" element={<SeoCityPage city="nordsjaelland" />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
